import {Model} from 'vue-mc';
//import { boolean , equal , integer , min , required , string , and , length , alphanumeric } from 'vue-mc/validation';

export class PerfilUsuarioModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
        username : ""
      , foto: ""
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      username:username=>username
      , foto:foto=>foto
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}


// WEBPACK FOOTER //
// ./src/models/seguridad/perfil-usuario.js